import React, { useCallback, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Box, Button, Text } from 'pcln-design-system'
import { Menu, MenuItem } from 'pcln-menu'

const IconWrapper = styled(Box)`
  height: 24px;
  & > svg {
    border-radius: 4px;
  }
`

const LanguageSelectorWrapper = styled(Box)`
  button {
    padding: 8px;
  }
`

function LanguageSelector({ className, buttonProps, languages, initialLanguage, onChange }) {
  const [languageCode, setLanguageCode] = useState(initialLanguage)
  const onLanguageCodeChange = useCallback(
    (code) => {
      setLanguageCode(code)
      onChange && onChange(code)
    },
    [onChange]
  )
  const memoLanguages = useMemo(
    () =>
      languages &&
      languages.map((language) => {
        const selected = language.code === languageCode
        const Icon = language.icon
        const onClick = () => onLanguageCodeChange(language.code)
        return (
          <MenuItem key={language.code} selected={selected} onClick={onClick}>
            <IconWrapper>
              <Icon width={32} height={24} />
            </IconWrapper>
            <Text regular ml={3}>
              {language.label}
            </Text>
          </MenuItem>
        )
      }),
    [languages, languageCode, onLanguageCodeChange]
  )

  if (!languages || languages.length === 0) {
    return null
  }

  const currentLanguage = languages.find((language) => language.code === languageCode)
  const CurrentLanguageIcon = currentLanguage?.icon

  const iconTitle = `${currentLanguage.label}, Select your language`

  const CurrentIcon = () => (
    <IconWrapper>
      <CurrentLanguageIcon title={iconTitle} width={32} height={24} />
    </IconWrapper>
  )

  return (
    <LanguageSelectorWrapper>
      <Menu
        className={className}
        buttonProps={buttonProps}
        buttonText={<CurrentIcon />}
        size={['singleColumn', null, null, 'twoColumns']}
      >
        {memoLanguages}
      </Menu>
    </LanguageSelectorWrapper>
  )
}

LanguageSelector.displayName = 'LanguageSelector'

LanguageSelector.propTypes = {
  className: PropTypes.string,
  buttonProps: PropTypes.shape(Button.propTypes),
  languages: PropTypes.array,
  initialLanguage: PropTypes.string,
  onChange: PropTypes.func,
}

LanguageSelector.defaultProps = {
  initialLanguage: 'USA',
}

export default LanguageSelector
